import type { ErrorEvent } from '@sentry/react'

const FORBIDDEN_REPORTING_VALUE_MESSAGE = 'Reporting payload contains image or binary data'

function isForbiddenBinary(value: unknown): boolean {
  return (typeof Blob !== 'undefined' && value instanceof Blob)
    || (typeof File !== 'undefined' && value instanceof File)
    || (typeof ImageBitmap !== 'undefined' && value instanceof ImageBitmap)
}

function containsForbiddenBinary(value: unknown, seen: Set<object>): boolean {
  if (isForbiddenBinary(value)) return true
  if (typeof value !== 'object' || value === null) return false
  if (seen.has(value)) return false
  seen.add(value)
  if (Array.isArray(value)) return value.some((item) => containsForbiddenBinary(item, seen))
  return Object.values(value).some((item) => containsForbiddenBinary(item, seen))
}

export function stripUrlQuery(url: string): string {
  const queryStart = url.indexOf('?')
  if (queryStart < 0) return url
  const fragmentStart = url.indexOf('#', queryStart)
  return fragmentStart < 0
    ? url.slice(0, queryStart)
    : `${url.slice(0, queryStart)}${url.slice(fragmentStart)}`
}

export function beforeSendReportingEvent(event: ErrorEvent, production: boolean): ErrorEvent | null {
  if (containsForbiddenBinary(event.extra, new Set())) {
    if (production) return null
    throw new Error(FORBIDDEN_REPORTING_VALUE_MESSAGE)
  }
  const request = event.request
  return request?.url
    ? { ...event, request: { ...request, url: stripUrlQuery(request.url) } }
    : event
}
